import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../styles/login.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ozlogo from "../assets/images/ourzest-logo.png";

// Role to Dashboard Routes
const ROUTES = {
  'super_admin': '/DashboardSuperAdmin',
  'superadmin': '/DashboardSuperAdmin',
  'admin_pos': '/DashboardPOS',
  'manager_pos': '/DashboardPOS',
  'user_pos': '/DashboardPOS',
  'viewer_pos': '/DashboardPOS',
  'salesman_pos': '/DashboardPOS',
  'admin_po': '/DashboardPO',
  'manager_po': '/DashboardPO',
  'user_po': '/DashboardPO',
  'viewer_po': '/DashboardPO',
  'admin_fabrics': '/DashboardFabrics',
  'manager_fabrics': '/DashboardFabrics',
  'user_fabrics': '/DashboardFabrics',
  'viewer_fabrics': '/DashboardFabrics',
  'admin_mechanicsth': '/DashboardMechanicsTh',
  'manager_mechanicsth': '/DashboardMechanicsTh',
  'user_mechanicsth': '/DashboardMechanicsTh',
  'viewer_mechanicsth': '/DashboardMechanicsTh',
  'admin_mechanicsap': '/DashboardMechanicsAp',
  'manager_mechanicsap': '/DashboardMechanicsAp',
  'user_mechanicsap': '/DashboardMechanicsAp',
  'viewer_mechanicsap': '/DashboardMechanicsAp',
  'admin_hardwareth': '/DashboardHardwareTh',
  'manager_hardwareth': '/DashboardHardwareTh',
  'user_hardwareth': '/DashboardHardwareTh',
  'viewer_hardwareth': '/DashboardHardwareTh',
  'admin_hardwareap': '/DashboardHardwareAp',
  'manager_hardwareap': '/DashboardHardwareAp',
  'user_hardwareap': '/DashboardHardwareAp',
  'viewer_hardwareap': '/DashboardHardwareAp',

  // AUTOS
  'admin_autosth': '/DashboardAutosTh',
  'manager_autosth': '/DashboardAutosTh',
  'user_autosth': '/DashboardAutosTh',
  'viewer_autosth': '/DashboardAutosTh',
  'admin_autosap': '/DashboardAutosAp',
  'manager_autosap': '/DashboardAutosAp',
  'user_autosap': '/DashboardAutosAp',
  'viewer_autosap': '/DashboardAutosAp',


  // PHARMACY
  'admin_pharmacy': '/DashboardPharmacy',
  'manager_pharmacy': '/DashboardPharmacy',
  'user_pharmacy': '/DashboardPharmacy',
  'viewer_pharmacy': '/DashboardPharmacy',
  'admin_pharmacy': '/DashboardPharmacy',
  'manager_pharmacy': '/DashboardPharmacy',
  'user_pharmacy': '/DashboardPharmacy',
  'viewer_pharmacy': '/DashboardPharmacy',


  // BUSINESS MODULE
  'admin_cosmetics': '/BusinessDashboard',
  'manager_cosmetics': '/BusinessDashboard',
  'user_cosmetics': '/BusinessDashboard',
  'viewer_cosmetics': '/BusinessDashboard',
  
};

// Translations Dictionary
const TRANSLATIONS = {
  en: {
    welcome: "Welcome Back",
    slogan: "Unified Business Ecosystem",
    username: "Username",
    password: "Password",
    remember: "Remember me",
    forgot: "Forgot password?",
    signin: "Sign In",
    loading: "Authenticating...",
    contact: "Contact Administrator",
    copyright: "© OurZest (Pvt LTD.) v2.0",
    theme: "Theme Color",
    access: "Access your unified workspace",
    clickHere: "Click here",
    user_inactive: "Account Inactive",
    user_inactive_message: "Your account is inactive. Please contact your administrator to reactivate your account.",
    user_suspended: "Account Suspended",
    user_suspended_message: "Your account has been suspended. Please contact your administrator.",
    subscription_expired: "⚠️ Subscription Expired",
    subscription_expired_message: "Your subscription has expired. Please renew to continue accessing the system.",
    subscription_cancelled: "Subscription Cancelled",
    subscription_cancelled_message: "Your subscription has been cancelled. Please contact your administrator to reactivate.",
    subscription_pending: "Subscription Pending",
    subscription_pending_message: "Your subscription is pending approval. Please wait for administrator approval.",
    no_subscription: "No Subscription Found",
    no_subscription_message: "No subscription found. Please purchase a subscription to access the system.",
    subscriptionStatus: "Subscription Status",
    totalSubscriptions: "Total",
    activeSubscriptions: "Active",
    expiredSubscriptions: "Expired",
    cancelledSubscriptions: "Cancelled",
    pendingSubscriptions: "Pending",
    daysRemaining: "Days Remaining",
    contactAdmin: "Please contact your administrator for assistance",
    close: "Close",
    renewNow: "Renew Now",
    userStatus: "Account Status",
    needHelp: "Need Help?",
    contactSupport: "Contact Support"
  },
  ur: {
    welcome: "خوش آمدید",
    slogan: "متحد بزنس ایکو سسٹم",
    username: "صارف نام",
    password: "پاس ورڈ",
    remember: "مجھے یاد رکھیں",
    forgot: "پاس ورڈ بھول گئے؟",
    signin: "لاگ ان کریں",
    loading: "تصدیق ہو رہی ہے...",
    contact: "ایڈمنسٹریٹر سے رابطہ کریں",
    copyright: "© OurZest (Pvt LTD.) v2.0",
    theme: "تھیم کا رنگ",
    access: "اپنے متحد کام کی جگہ تک رسائی حاصل کریں",
    clickHere: "یہاں کلک کریں",
    user_inactive: "اکاؤنٹ غیر فعال",
    user_inactive_message: "آپ کا اکاؤنٹ غیر فعال ہے۔ براہ کرم دوبارہ فعال کرنے کے لیے اپنے منتظم سے رابطہ کریں۔",
    user_suspended: "اکاؤنٹ معطل",
    user_suspended_message: "آپ کا اکاؤنٹ معطل کر دیا گیا ہے۔ براہ کرم اپنے منتظم سے رابطہ کریں۔",
    subscription_expired: "⚠️ سبسکرپشن میعاد ختم",
    subscription_expired_message: "آپ کی سبسکرپشن میعاد ختم ہو گئی ہے۔ براہ کرم سسٹم تک رسائی جاری رکھنے کے لیے تجدید کریں۔",
    subscription_cancelled: "سبسکرپشن منسوخ",
    subscription_cancelled_message: "آپ کی سبسکرپشن منسوخ کر دی گئی ہے۔ براہ کرم دوبارہ فعال کرنے کے لیے اپنے منتظم سے رابطہ کریں۔",
    subscription_pending: "سبسکرپشن زیر التواء",
    subscription_pending_message: "آپ کی سبسکرپشن منظوری کے زیر التواء ہے۔ براہ کرم منتظم کی منظوری کا انتظار کریں۔",
    no_subscription: "کوئی سبسکرپشن نہیں",
    no_subscription_message: "کوئی سبسکرپشن نہیں ملی۔ براہ کرم سسٹم تک رسائی کے لیے سبسکرپشن خریدیں۔",
    subscriptionStatus: "سبسکرپشن کی حالت",
    totalSubscriptions: "کل",
    activeSubscriptions: "فعال",
    expiredSubscriptions: "میعاد ختم",
    cancelledSubscriptions: "منسوخ",
    pendingSubscriptions: "زیر التواء",
    daysRemaining: "باقی دن",
    contactAdmin: "براہ کرم مدد کے لیے اپنے منتظم سے رابطہ کریں",
    close: "بند کریں",
    renewNow: "ابھی تجدید کریں",
    userStatus: "اکاؤنٹ کی حالت",
    needHelp: "مدد چاہیے؟",
    contactSupport: "سپورٹ سے رابطہ کریں"
  },
  ar: {
    welcome: "مرحبا بعودتك",
    slogan: "النظام الإيكولوجي للأعمال الموحد",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    remember: "تذكرني",
    forgot: "نسيت كلمة المرور؟",
    signin: "تسجيل الدخول",
    loading: "جاري المصادقة...",
    contact: "الاتصال بالمسؤول",
    copyright: "© OurZest (Pvt LTD.) v2.0",
    theme: "لون السمة",
    access: "الوصول إلى مساحة العمل الموحدة الخاصة بك",
    clickHere: "انقر هنا",
    user_inactive: "الحساب غير نشط",
    user_inactive_message: "حسابك غير نشط. يرجى الاتصال بالمسؤول لإعادة التنشيط.",
    user_suspended: "الحساب معلق",
    user_suspended_message: "تم تعليق حسابك. يرجى الاتصال بالمسؤول.",
    subscription_expired: "⚠️ انتهت صلاحية الاشتراك",
    subscription_expired_message: "انتهت صلاحية اشتراكك. يرجى التجديد لمواصلة الوصول إلى النظام.",
    subscription_cancelled: "تم إلغاء الاشتراك",
    subscription_cancelled_message: "تم إلغاء اشتراكك. يرجى الاتصال بالمسؤول لإعادة التنشيط.",
    subscription_pending: "الاشتراك معلق",
    subscription_pending_message: "اشتراكك في انتظار الموافقة. يرجى انتظار موافقة المسؤول.",
    no_subscription: "لا يوجد اشتراك",
    no_subscription_message: "لا يوجد اشتراك. يرجى شراء اشتراك للوصول إلى النظام.",
    subscriptionStatus: "حالة الاشتراك",
    totalSubscriptions: "الإجمالي",
    activeSubscriptions: "نشط",
    expiredSubscriptions: "منتهي الصلاحية",
    cancelledSubscriptions: "ملغى",
    pendingSubscriptions: "معلق",
    daysRemaining: "الأيام المتبقية",
    contactAdmin: "يرجى الاتصال بالمسؤول الخاص بك للحصول على المساعدة",
    close: "إغلاق",
    renewNow: "جدد الآن",
    userStatus: "حالة الحساب",
    needHelp: "بحاجة إلى مساعدة؟",
    contactSupport: "اتصل بالدعم"
  },
  es: {
    welcome: "Bienvenido de nuevo",
    slogan: "Ecosistema Empresarial Unificado",
    username: "Nombre de usuario",
    password: "Contraseña",
    remember: "Recuérdame",
    forgot: "¿Olvidó su contraseña?",
    signin: "Iniciar sesión",
    loading: "Autenticando...",
    contact: "Contactar administrador",
    copyright: "© OurZest (Pvt LTD.) v2.0",
    theme: "Color del tema",
    access: "Accede a tu espacio de trabajo unificado",
    clickHere: "Haga clic aquí",
    user_inactive: "Cuenta Inactiva",
    user_inactive_message: "Su cuenta está inactiva. Contacte al administrador para reactivar.",
    user_suspended: "Cuenta Suspendida",
    user_suspended_message: "Su cuenta ha sido suspendida. Contacte al administrador.",
    subscription_expired: "⚠️ Suscripción Expirada",
    subscription_expired_message: "Su suscripción ha expirado. Renueve para continuar accediendo al sistema.",
    subscription_cancelled: "Suscripción Cancelada",
    subscription_cancelled_message: "Su suscripción ha sido cancelada. Contacte al administrador para reactivar.",
    subscription_pending: "Suscripción Pendiente",
    subscription_pending_message: "Su suscripción está pendiente de aprobación. Espere la aprobación del administrador.",
    no_subscription: "Sin Suscripción",
    no_subscription_message: "No se encontró una suscripción. Adquiera una suscripción para acceder al sistema.",
    subscriptionStatus: "Estado de Suscripción",
    totalSubscriptions: "Total",
    activeSubscriptions: "Activas",
    expiredSubscriptions: "Expiradas",
    cancelledSubscriptions: "Canceladas",
    pendingSubscriptions: "Pendientes",
    daysRemaining: "Días Restantes",
    contactAdmin: "Contacte a su administrador para asistencia",
    close: "Cerrar",
    renewNow: "Renovar Ahora",
    userStatus: "Estado de la Cuenta",
    needHelp: "¿Necesita ayuda?",
    contactSupport: "Contactar Soporte"
  }
};

const LANGUAGES = {
  en: { name: 'English', icon: '🇺🇸', dir: 'ltr' },
  ur: { name: 'اردو', icon: '🇵🇰', dir: 'rtl' },
  ps: { name: 'پښتو', icon: '🇦🇫', dir: 'rtl' },
  ar: { name: 'عربي', icon: '🇸🇦', dir: 'rtl' },
  es: { name: 'Español', icon: '🇪🇸', dir: 'ltr' },
  fr: { name: 'Français', icon: '🇫🇷', dir: 'ltr' },
  de: { name: 'Deutsch', icon: '🇩🇪', dir: 'ltr' },
  zh: { name: '中文', icon: '🇨🇳', dir: 'ltr' },
  hi: { name: 'हिन्दी', icon: '🇮🇳', dir: 'ltr' },
  ru: { name: 'Русский', icon: '🇷🇺', dir: 'ltr' },
  ja: { name: '日本語', icon: '🇯🇵', dir: 'ltr' },
  pt: { name: 'Português', icon: '🇵🇹', dir: 'ltr' },
  it: { name: 'Italiano', icon: '🇮🇹', dir: 'ltr' },
  tr: { name: 'Türkçe', icon: '🇹🇷', dir: 'ltr' },
  fa: { name: 'فارسی', icon: '🇮🇷', dir: 'rtl' },
  bn: { name: 'বাংলা', icon: '🇧🇩', dir: 'ltr' }
};

const THEME_COLORS = [
  { name: 'Indigo', value: '#6366f1' },
  { name: 'Emerald', value: '#10b981' },
  { name: 'Rose', value: '#f43f5e' },
  { name: 'Amber', value: '#f59e0b' },
  { name: 'Violet', value: '#8b5cf6' },
  { name: 'Cyan', value: '#06b6d4' },
  { name: 'Fuchsia', value: '#d946ef' },
  { name: 'Sky', value: '#0ea5e9' }
];

const ANIMATED_FEATURES = [
  { icon: "fas fa-code", text: "Custom Software Development" },
  { icon: "fas fa-laptop-code", text: "Web Application Development" },
  { icon: "fas fa-mobile-alt", text: "Mobile App Development" },
  { icon: "fas fa-cloud", text: "Cloud-Based Solutions" },
  { icon: "fas fa-database", text: "Database Design & Management" },
  { icon: "fas fa-cogs", text: "Enterprise Software Solutions" },
  { icon: "fas fa-store", text: "Retail Management Systems" },
  { icon: "fas fa-chart-line", text: "Business Analytics" },
  { icon: "fas fa-users-cog", text: "HR Management Systems" },
  { icon: "fas fa-robot", text: "AI-Powered Solutions" }
];

// Apply theme colors
const applyThemeColors = (color) => {
  if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
    color = '#8cd200';
  }
  
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);
  
  const lighten = (amount) => {
    const newR = Math.min(255, r + amount);
    const newG = Math.min(255, g + amount);
    const newB = Math.min(255, b + amount);
    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  };
  
  const darken = (amount) => {
    const newR = Math.max(0, r - amount);
    const newG = Math.max(0, g - amount);
    const newB = Math.max(0, b - amount);
    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  };
  
  document.documentElement.style.setProperty('--oz-primary-color', color);
  document.documentElement.style.setProperty('--oz-primary-dark', darken(40));
  document.documentElement.style.setProperty('--oz-primary-light', lighten(40));
  document.documentElement.style.setProperty('--oz-primary-ultralight', lighten(80));
  document.documentElement.style.setProperty('--oz-primary-gradient', `linear-gradient(135deg, ${color}, ${darken(30)})`);
  document.documentElement.style.setProperty('--oz-primary-shadow', `${color}20`);
  
  let metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (!metaThemeColor) {
    metaThemeColor = document.createElement('meta');
    metaThemeColor.setAttribute('name', 'theme-color');
    document.head.appendChild(metaThemeColor);
  }
  metaThemeColor.setAttribute('content', color);
};

// Apply language direction
const applyLanguageDirection = (langCode) => {
  const langData = LANGUAGES[langCode];
  if (langData) {
    document.documentElement.dir = langData.dir;
    document.documentElement.lang = langCode;
    document.body.dir = langData.dir;
    document.documentElement.style.direction = langData.dir;
  }
};

// ==============================================
// 3D ANIMATED SUBSCRIPTION POPUP - FIXED
// Updated: Inactive = RED, No Subscription = YELLOW
// ==============================================
const SubscriptionPopup3D = ({ 
  isOpen, 
  onClose, 
  blockReason, 
  message, 
  subscriptionSummary, 
  subscriptions,
  userStatus,
  subscriptionStatus,
  translations,
  onRenew
}) => {
  const cardRef = useRef(null);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });

  if (!isOpen) return null;

  const isExpired = blockReason === 'subscription_expired';
  const isExpiringSoon = subscriptionSummary?.days_until_expiry !== null && 
                         subscriptionSummary?.days_until_expiry <= 7 && 
                         subscriptionSummary?.days_until_expiry > 0;

  // Get config based on block reason - UPDATED COLORS
  const getBlockConfig = () => {
    const configs = {
      'subscription_expired': {
        icon: 'fa-exclamation-triangle',
        color: '#ef4444', // RED
        bg: 'rgba(239, 68, 68, 0.12)',
        border: '#ef4444',
        title: translations.subscription_expired || '⚠️ Subscription Expired',
        glowColor: 'rgba(239, 68, 68, 0.2)',
        cssClass: 'oz-popup-3d-icon-expired'
      },
      'subscription_cancelled': {
        icon: 'fa-times-circle',
        color: '#f59e0b', // YELLOW
        bg: 'rgba(245, 158, 11, 0.12)',
        border: '#f59e0b',
        title: translations.subscription_cancelled || 'Subscription Cancelled',
        glowColor: 'rgba(245, 158, 11, 0.2)',
        cssClass: 'oz-popup-3d-icon-nosub'
      },
      'subscription_pending': {
        icon: 'fa-hourglass-half',
        color: '#f59e0b', // YELLOW
        bg: 'rgba(245, 158, 11, 0.12)',
        border: '#f59e0b',
        title: translations.subscription_pending || 'Subscription Pending',
        glowColor: 'rgba(245, 158, 11, 0.2)',
        cssClass: 'oz-popup-3d-icon-nosub'
      },
      'no_subscription': {
        icon: 'fa-file-invoice',
        color: '#f59e0b', // YELLOW - explicit for no subscription
        bg: 'rgba(245, 158, 11, 0.12)',
        border: '#f59e0b',
        title: translations.no_subscription || 'No Subscription Found',
        glowColor: 'rgba(245, 158, 11, 0.2)',
        cssClass: 'oz-popup-3d-icon-nosub' // Yellow class
      },
      'user_inactive': {
        icon: 'fa-user-slash',
        color: '#ef4444', // RED - changed from gray to red
        bg: 'rgba(239, 68, 68, 0.12)', // Changed from gray to red
        border: '#ef4444', // Changed from gray to red
        title: translations.user_inactive || 'Account Inactive',
        glowColor: 'rgba(239, 68, 68, 0.2)', // Changed from gray to red
        cssClass: 'oz-popup-3d-icon-inactive' // Red class
      },
      'user_suspended': {
        icon: 'fa-ban',
        color: '#ef4444', // RED
        bg: 'rgba(239, 68, 68, 0.12)',
        border: '#ef4444',
        title: translations.user_suspended || 'Account Suspended',
        glowColor: 'rgba(239, 68, 68, 0.2)',
        cssClass: 'oz-popup-3d-icon-inactive'
      },
      'default': {
        icon: 'fa-exclamation-triangle',
        color: '#ef4444',
        bg: 'rgba(239, 68, 68, 0.12)',
        border: '#ef4444',
        title: 'Access Denied',
        glowColor: 'rgba(239, 68, 68, 0.2)',
        cssClass: 'oz-popup-3d-icon-inactive'
      }
    };
    return configs[blockReason] || configs['default'];
  };

  const config = getBlockConfig();

  // Get badge class based on status
  const getBadgeClass = () => {
    if (blockReason === 'user_inactive' || blockReason === 'user_suspended') {
      return 'oz-popup-3d-badge-inactive';
    }
    if (blockReason === 'no_subscription' || blockReason === 'subscription_cancelled' || blockReason === 'subscription_pending') {
      return 'oz-popup-3d-badge-nosub';
    }
    if (blockReason === 'subscription_expired') {
      return 'oz-popup-3d-badge-expired';
    }
    return 'oz-popup-3d-badge-inactive';
  };

  // Get summary value class based on status
  const getSummaryValueClass = (label) => {
    if (blockReason === 'user_inactive' || blockReason === 'user_suspended') {
      return 'oz-popup-3d-summary-value-inactive';
    }
    if (blockReason === 'no_subscription' || blockReason === 'subscription_cancelled' || blockReason === 'subscription_pending') {
      return 'oz-popup-3d-summary-value-nosub';
    }
    if (blockReason === 'subscription_expired') {
      return 'oz-popup-3d-summary-value-expired';
    }
    return '';
  };

  // Mouse move handler for 3D effect
  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * -8;
    const rotateY = ((x - centerX) / centerX) * 8;
    setRotation({ x: rotateX, y: rotateY });
  };

  const handleMouseLeave = () => {
    setRotation({ x: 0, y: 0 });
  };

  return (
    <div className="oz-popup-3d-overlay" onClick={onClose}>
      <div 
        className="oz-popup-3d-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div 
          ref={cardRef}
          className={`oz-popup-3d-card ${config.cssClass || ''}`}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{
            transform: `perspective(800px) rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`
          }}
        >
          {/* Glow Effect */}
          <div className="oz-popup-3d-glow" style={{ background: config.glowColor }}></div>
          
          {/* Smooth Gradient Orbs */}
          <div className="oz-popup-3d-bg">
            <div className="oz-popup-3d-orb oz-popup-3d-orb-1"></div>
            <div className="oz-popup-3d-orb oz-popup-3d-orb-2"></div>
          </div>

          {/* Icon Section - with dynamic color */}
          <div className="oz-popup-3d-icon-wrapper">
            <div className="oz-popup-3d-icon" style={{ background: config.bg, borderColor: config.border }}>
              <i className={`fas ${config.icon}`} style={{ color: config.color }}></i>
            </div>
            {isExpired && (
              <div className="oz-popup-3d-pulse-ring">
                <div className="oz-popup-3d-pulse-ring-inner"></div>
              </div>
            )}
          </div>

          {/* Content */}
          <div className="oz-popup-3d-content">
            <h2 className="oz-popup-3d-title" style={{ color: config.color }}>
              {config.title}
            </h2>
            
            <p className="oz-popup-3d-message">{message}</p>

            {/* Status Badge - uses appropriate class */}
            <div className={`oz-popup-3d-badge ${getBadgeClass()}`}>
              <i className="fas fa-info-circle"></i>
              <span>
                {blockReason === 'user_inactive' && (translations.userStatus || 'INACTIVE')}
                {blockReason === 'user_suspended' && (translations.userStatus || 'SUSPENDED')}
                {blockReason === 'no_subscription' && 'NO SUBSCRIPTION'}
                {blockReason === 'subscription_expired' && 'EXPIRED'}
                {blockReason === 'subscription_cancelled' && 'CANCELLED'}
                {blockReason === 'subscription_pending' && 'PENDING'}
              </span>
            </div>

            {/* Subscription Summary */}
            {subscriptionSummary && (
              <div className="oz-popup-3d-summary">
                <div className="oz-popup-3d-summary-grid">
                  <div className="oz-popup-3d-summary-item">
                    <span className="oz-popup-3d-summary-label">
                      <i className="fas fa-list"></i>
                      {translations.totalSubscriptions || 'Total'}
                    </span>
                    <span className={`oz-popup-3d-summary-value ${getSummaryValueClass('total')}`}>
                      {subscriptionSummary.total || 0}
                    </span>
                  </div>
                  <div className="oz-popup-3d-summary-item">
                    <span className="oz-popup-3d-summary-label">
                      <i className="fas fa-check-circle" style={{ color: '#10b981' }}></i>
                      {translations.activeSubscriptions || 'Active'}
                    </span>
                    <span className="oz-popup-3d-summary-value oz-popup-3d-active">
                      {subscriptionSummary.active || 0}
                    </span>
                  </div>
                  <div className="oz-popup-3d-summary-item">
                    <span className="oz-popup-3d-summary-label">
                      <i className="fas fa-times-circle" style={{ color: '#ef4444' }}></i>
                      {translations.expiredSubscriptions || 'Expired'}
                    </span>
                    <span className="oz-popup-3d-summary-value oz-popup-3d-expired">
                      {subscriptionSummary.expired || 0}
                    </span>
                  </div>
                  <div className="oz-popup-3d-summary-item">
                    <span className="oz-popup-3d-summary-label">
                      <i className="fas fa-ban" style={{ color: '#f59e0b' }}></i>
                      {translations.cancelledSubscriptions || 'Cancelled'}
                    </span>
                    <span className="oz-popup-3d-summary-value oz-popup-3d-cancelled">
                      {subscriptionSummary.cancelled || 0}
                    </span>
                  </div>
                </div>
                
                {subscriptionSummary.days_until_expiry !== null && subscriptionSummary.days_until_expiry >= 0 && (
                  <div className="oz-popup-3d-days">
                    <i className="fas fa-clock"></i>
                    <span>
                      {translations.daysRemaining || 'Days Remaining'}: 
                      <strong>{subscriptionSummary.days_until_expiry}</strong> days
                    </span>
                  </div>
                )}
              </div>
            )}

            {/* Renew Button - only for expired or no subscription */}
            {(isExpired || blockReason === 'no_subscription') && (
              <button className="oz-popup-3d-renew-btn" onClick={onRenew}>
                <i className="fas fa-sync-alt"></i>
                <span>{blockReason === 'no_subscription' ? 'Get Subscription' : (translations.renewNow || 'Renew Now')}</span>
                <i className="fas fa-arrow-right"></i>
              </button>
            )}

            {/* Close Button */}
            <button className="oz-popup-3d-close-btn" onClick={onClose}>
              <i className="fas fa-times"></i>
              <span>{translations.close || 'Close'}</span>
            </button>

            {/* Footer */}
            <div className="oz-popup-3d-footer">
              <p>
                <i className="fas fa-headset"></i>
                {translations.needHelp || 'Need Help?'} 
                <a href="https://wa.me/message/6D64QLRVE5YGG1" target="_blank" rel="noopener noreferrer">
                  {translations.contactSupport || 'Contact Support'}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
// ==============================================
// MAIN LOGIN COMPONENT
// ==============================================
const Login = () => {
  const savedTheme = localStorage.getItem('ourzest_theme');
  const savedLanguage = localStorage.getItem('ourzest_language');
  const savedUsername = localStorage.getItem('ourzest_username');
  const savedRemember = localStorage.getItem('ourzest_remember') === 'true';
  
  const [formData, setFormData] = useState({
    username: savedUsername || "",
    password: "",
    remember: savedRemember,
    themeColor: savedTheme || '#8cd200',
    language: savedLanguage || 'en'
  });
  
  const [texts, setTexts] = useState(TRANSLATIONS[formData.language] || TRANSLATIONS.en);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    blockReason: '',
    message: '',
    summary: null,
    subscriptions: null,
    userStatus: '',
    subscriptionStatus: ''
  });
  
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const languageDropdownRef = useRef(null);
  const featureIntervalRef = useRef(null);
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const particlesRef = useRef([]);
  
  // Initialize
  useEffect(() => {
    applyThemeColors(formData.themeColor);
    applyLanguageDirection(formData.language);
    setIsInitialized(true);
    
    featureIntervalRef.current = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % ANIMATED_FEATURES.length);
    }, 2000);
    
    initParticles();
    startAnimation();
    
    const handleResize = () => {
      if (canvasRef.current) {
        const container = canvasRef.current.parentElement;
        canvasRef.current.width = container.clientWidth;
        canvasRef.current.height = container.clientHeight;
        initParticles();
      }
    };
    window.addEventListener('resize', handleResize);
    
    return () => {
      if (featureIntervalRef.current) clearInterval(featureIntervalRef.current);
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const initParticles = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const container = canvas.parentElement;
    canvas.width = container.clientWidth;
    canvas.height = container.clientHeight;
    
    particlesRef.current = [];
    const particleCount = 80;
    
    for (let i = 0; i < particleCount; i++) {
      particlesRef.current.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 2 + 1,
        speedX: (Math.random() - 0.5) * 1.5,
        speedY: (Math.random() - 0.5) * 1.5,
        color: `rgba(255, 255, 255, ${Math.random() * 0.3 + 0.1})`
      });
    }
  };
  
  const startAnimation = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const particles = particlesRef.current;
    
    const animate = () => {
      if (!canvas || !ctx) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      particles.forEach((particle, i) => {
        particle.x += particle.speedX;
        particle.y += particle.speedY;
        
        if (particle.x <= 0 || particle.x >= canvas.width) particle.speedX *= -1;
        if (particle.y <= 0 || particle.y >= canvas.height) particle.speedY *= -1;
        
        particle.x = Math.max(0, Math.min(canvas.width, particle.x));
        particle.y = Math.max(0, Math.min(canvas.height, particle.y));
        
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.fill();
        
        particles.forEach((otherParticle, j) => {
          if (i !== j) {
            const dx = particle.x - otherParticle.x;
            const dy = particle.y - otherParticle.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            
            if (distance < 100) {
              const opacity = 0.08 * (1 - distance / 100);
              ctx.beginPath();
              ctx.moveTo(particle.x, particle.y);
              ctx.lineTo(otherParticle.x, otherParticle.y);
              ctx.strokeStyle = `rgba(255, 255, 255, ${opacity})`;
              ctx.lineWidth = 0.5;
              ctx.stroke();
            }
          }
        });
      });
      
      animationRef.current = requestAnimationFrame(animate);
    };
    
    animate();
  };
  
  const handleThemeChange = (color) => {
    setFormData(prev => ({ ...prev, themeColor: color }));
    applyThemeColors(color);
    localStorage.setItem('ourzest_theme', color);
  };
  
  const handleLanguageChange = (langCode) => {
    setFormData(prev => ({ ...prev, language: langCode }));
    applyLanguageDirection(langCode);
    setTexts(TRANSLATIONS[langCode] || TRANSLATIONS.en);
    localStorage.setItem('ourzest_language', langCode);
    setShowLanguageDropdown(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (error) setError("");
  };
  
  const validateForm = () => {
    if (!formData.username.trim()) {
      setError(texts.username + " is required");
      return false;
    }
    if (!formData.password) {
      setError(texts.password + " is required");
      return false;
    }
    return true;
  };
  
  const handleRenew = () => {
    setShowPopup(false);
    window.open('https://wa.me/message/6D64QLRVE5YGG1', '_blank');
  };
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setShowPopup(false);
    
    if (!validateForm()) return;
    
    setLoading(true);
    
    try {
        const response = await fetch('https://ourzestapp.online/oz_backend/login.php', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                username: formData.username, 
                password: formData.password,
                remember: formData.remember,
                theme_color: formData.themeColor,
                language: formData.language
            }),
        });
        
        const data = await response.json();
        
        // Check if login is blocked - show popup
        if (!data.success && data.login_status) {
            setPopupData({
                blockReason: data.login_status,
                message: data.message,
                summary: data.subscription_summary || null,
                subscriptions: data.subscriptions || null,
                userStatus: data.user_status || '',
                subscriptionStatus: data.subscription_status || ''
            });
            setShowPopup(true);
            setLoading(false);
            return;
        }
        
        if (data.success) {
            const userRole = data.role;
            
            // SUPER ADMIN - Always allowed
            if (data.is_super_admin || userRole === 'super_admin' || userRole === 'superadmin') {
                const route = ROUTES['super_admin'];
                
                const userData = {
                    id: data.user?.id,
                    username: data.user?.username || formData.username,
                    fullname: data.user?.fullname || formData.username,
                    role: 'super_admin',
                    themeColor: formData.themeColor,
                    language: formData.language,
                    businessName: data.user?.business_name || "OurZest Corp",
                    email: data.user?.email || `${formData.username}@oz.com`,
                    shop_id: data.user?.shop_id,
                    shop_name: data.user?.shop_name,
                    shop_code: data.user?.shop_code,
                    status: data.user?.status || 'active',
                    is_super_admin: true,
                    subscription: data.subscription || null,
                    login_status: data.login_status || 'super_admin'
                };
                
                localStorage.setItem('ourzest_theme', formData.themeColor);
                localStorage.setItem('ourzest_language', formData.language);
                localStorage.setItem('user_role', 'super_admin');
                localStorage.setItem('user', JSON.stringify(userData));
                localStorage.setItem("auth_timestamp", Date.now().toString());
                localStorage.setItem('is_super_admin', 'true');
                
                setUser(userData);
                setSuccess("Super Admin login successful! Redirecting...");
                
                setTimeout(() => {
                    navigate(route);
                }, 1500);
                return;
            }
            
            // Regular user flow
            const route = ROUTES[userRole];
            
            if (!route) {
                setError(`No dashboard available for role: ${userRole}`);
                setLoading(false);
                return;
            }
            
            const userData = {
                id: data.user?.id,
                username: data.user?.username || formData.username,
                fullname: data.user?.fullname || formData.username,
                role: userRole,
                themeColor: formData.themeColor,
                language: formData.language,
                businessName: data.user?.business_name || "OurZest Corp",
                email: data.user?.email || `${formData.username}@oz.com`,
                shop_id: data.user?.shop_id,
                shop_name: data.user?.shop_name,
                shop_code: data.user?.shop_code,
                status: data.user?.status || 'active',
                subscription: data.subscription || null,
                login_status: data.login_status || 'active'
            };
            
            localStorage.setItem('ourzest_theme', formData.themeColor);
            localStorage.setItem('ourzest_language', formData.language);
            localStorage.setItem('user_role', userRole);
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem("auth_timestamp", Date.now().toString());
            
            if (data.subscription) {
                localStorage.setItem('user_subscription', JSON.stringify(data.subscription));
            }
            
            if (formData.remember) {
                localStorage.setItem('ourzest_username', formData.username);
                localStorage.setItem('ourzest_remember', 'true');
            } else {
                localStorage.removeItem('ourzest_remember');
                localStorage.removeItem('ourzest_username');
            }
            
            setUser(userData);
            setSuccess(texts.signin + " successful! Redirecting...");
            
            setTimeout(() => {
                navigate(route);
            }, 1500);
            
        } else {
            setError(data.message || "Invalid username or password");
            setLoading(false);
        }
        
    } catch (error) {
        console.error("Login error:", error);
        setError("Cannot connect to server. Please check your connection.");
        setLoading(false);
    }
};
  
  if (!isInitialized) {
    return (
      <div className="oz-loading-screen">
        <div className="oz-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  
  return (
    <div className="oz-login-container">
      <SubscriptionPopup3D 
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        blockReason={popupData.blockReason}
        message={popupData.message}
        subscriptionSummary={popupData.summary}
        subscriptions={popupData.subscriptions}
        userStatus={popupData.userStatus}
        subscriptionStatus={popupData.subscriptionStatus}
        translations={texts}
        onRenew={handleRenew}
      />
      
      <div className="oz-login-branding">
        <canvas ref={canvasRef} className="oz-particle-canvas" />
        
        <div className="oz-brand-content">
          <div className="oz-brand-logo-animated">
            <img 
              src={ozlogo} 
              alt="OurZest Logo" 
              className="oz-static-logo"
            />
            <div className="oz-logo-rings"></div>
            <div className="oz-logo-rings delayed"></div>
          </div>
          
          <div className="oz-brand-text">
            <h1 className="oz-brand-title">
              <span className="oz-gradient-text">OURZEST-CORE</span>
            </h1>
            <p className="oz-brand-subtitle">{texts.slogan}</p>
          </div>
          
          <div className="oz-animated-features">
            <div className="oz-feature-icon-container">
              <div className="oz-feature-icon-wrapper">
                {ANIMATED_FEATURES.map((feature, index) => (
                  <div 
                    key={index}
                    className={`oz-feature-icon ${index === currentFeature ? 'active' : ''}`}
                  >
                    <i className={feature.icon}></i>
                    <span className="oz-feature-text">{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="oz-login-form-container">
        <div className="oz-login-form-wrapper">
          {error && (
            <div className="oz-alert oz-alert-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
              <button 
                className="oz-alert-close"
                onClick={() => setError("")}
                disabled={loading}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          )}
          
          {success && (
            <div className="oz-alert oz-alert-success">
              <i className="fas fa-check-circle"></i>
              <span>{success}</span>
              <button 
                className="oz-alert-close"
                onClick={() => setSuccess("")}
                disabled={loading}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          )}
          
          <div className="oz-form-header">
            <div className="oz-form-avatar">
              <i className="fas fa-user-circle"></i>
            </div>
            <h2>{texts.welcome}</h2>
            <p>{texts.access}</p>
          </div>
          
          <form onSubmit={handleLogin} className="oz-login-form" noValidate>
            <div className="oz-form-group">
              <div className="oz-input-container">
                <i className="fas fa-user oz-input-icon"></i>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleInputChange}
                  className="oz-form-control"
                  placeholder={texts.username}
                  autoComplete="username"
                  required
                  disabled={loading}
                />
                <label htmlFor="username" className="oz-input-label">
                  {texts.username}
                </label>
              </div>
            </div>
            
            <div className="oz-form-group">
              <div className="oz-input-container">
                <i className="fas fa-lock oz-input-icon"></i>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="oz-form-control"
                  placeholder={texts.password}
                  autoComplete="current-password"
                  required
                  disabled={loading}
                />
                <label htmlFor="password" className="oz-input-label">
                  {texts.password}
                </label>
                <button 
                  type="button"
                  className="oz-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                </button>
              </div>
            </div>
            
            <div className="oz-form-group">
              <label className="oz-theme-label">{texts.theme}</label>
              <div className="oz-theme-picker">
                <input
                  type="color"
                  name="themeColor"
                  value={formData.themeColor}
                  onChange={(e) => handleThemeChange(e.target.value)}
                  className="oz-theme-color-input"
                  disabled={loading}
                />
                <div className="oz-theme-presets">
                  {THEME_COLORS.map((color) => (
                    <button
                      key={color.value}
                      type="button"
                      className={`oz-theme-preset ${formData.themeColor === color.value ? 'active' : ''}`}
                      style={{ backgroundColor: color.value }}
                      onClick={() => !loading && handleThemeChange(color.value)}
                      title={color.name}
                      disabled={loading}
                    />
                  ))}
                </div>
              </div>
            </div>
            
            <div className="oz-form-options">
              <label className="oz-checkbox-container">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="remember"
                  checked={formData.remember}
                  onChange={handleInputChange}
                  disabled={loading}
                />
                <span className="oz-checkmark"></span>
                <span className="oz-checkbox-label">{texts.remember}</span>
              </label>
              <a href="https://wa.me/message/6D64QLRVE5YGG1" className="oz-forgot-password">
                {texts.forgot}
              </a>
            </div>
            
            <button 
              type="submit" 
              className="oz-submit-btn"
              disabled={loading}
              style={{ backgroundColor: formData.themeColor }}
            >
              {loading ? (
                <>
                  <div className="oz-btn-spinner"></div>
                  <span>{texts.loading}</span>
                </>
              ) : (
                <>
                  <span>{texts.signin}</span>
                  <i className="fas fa-arrow-right"></i>
                </>
              )}
            </button>
            
            <div className="oz-form-footer">
              <p>{texts.contact}? <a href="https://wa.me/message/6D64QLRVE5YGG1" className="oz-contact-link">{texts.clickHere}</a></p>
              <p className="oz-copyright">{texts.copyright}</p>
            </div>
          </form>
        </div>
      </div>
      
      {loading && (
        <div className="oz-loading-overlay">
          <div className="oz-loading-content">
            <div className="oz-loading-spinner"></div>
            <p>{texts.loading}</p>
            <p className="oz-loading-subtext">Please wait while we secure your session</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;